import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { CategoryOptionGroup, OptionGroupSaveRequestData } from "../../../../graphql/types"

export const createOptionGroupPayload = (
    payloadGroup: OptionGroupSaveRequestData,
    originGroup: Maybe<CategoryOptionGroup>
): CategoryOptionGroup => {
    return {
        id: payloadGroup.id,
        name: payloadGroup.name,
        displayName: payloadGroup.displayName,
        displayType: payloadGroup.displayType ?? "list",
        price: originGroup ? originGroup.price : [],
        isActive: payloadGroup.isActive,
        options: payloadGroup.options.map(o => ({
            id: o.id,
            categoryId: o.productId,
            name: o.name,
            kitchenName: o.kitchenName,
        })),
        addedToItems: originGroup ? originGroup.addedToItems : [],
    }
}

export const optionDuplicateDescription =
    "Duplicate Option Group - General settings and Individual Options. It won't duplicate to which Items the option group is added."
